export const SKELETON_SPEED = 2
export const SKELETON_MAIN_COLOR = '#F2F2F2'
export const SKELETON_WHITE_COLOR = '#ffffff'

export const SKELETON_FOREGROUND_COLOR = '#e5e5e5'
export const SKELETON_FOREGROUND_WHITE_COLOR = '#f3f3f3'
export const SKELETON_STYLES = {
  display: 'block',
}
